<template>
    <div id="homepage">
      <!-- 使用 HeaderComponent 组件 -->
      <HeaderComponent :key="$route.fullPath" :title="name" :subtitle="jobTitle" />
  
      <!-- 主体内容 -->
      <main>
        <PortfolioSection :portfolio="portfolio" />
      </main>
      
      <!-- 使用 FooterComponent 组件 -->
      <FooterComponent />
    </div>
  </template>
  
  <script>
  import $ from 'jquery';
  window.$ = window.jQuery = $;  
  
  import '@/assets/css/style.css';
  import '@/assets/sass/stylesupport.css';
  
  import '@/assets/js/javascript.js';
  import resumeData from '@/data/resumeData.js';
  
  import HeaderComponent from '@/components/common/HeaderComponent.vue';
  import FooterComponent from '@/components/common/FooterComponent.vue';

  import PortfolioSection from '@/components/common/PortfolioSection.vue';
  
  export default {
    name: 'HomePage',
    components: {
      HeaderComponent,
      FooterComponent,
      PortfolioSection,
    },
    data() {
      return {
        ...resumeData, 
      };
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        // 确保组件完全挂载后再初始化动画
        vm.$nextTick(() => {
          const headerComponent = vm.$refs.headerComponent;
          if (headerComponent) {
            headerComponent.initializeAnimations();
          }
        });
      });
    },
    beforeRouteUpdate(to, from, next) {
      // 路由更新时重新初始化动画
      this.$nextTick(() => {
        const headerComponent = this.$refs.headerComponent;
        if (headerComponent) {
          headerComponent.initializeAnimations();
        }
      });
      next();
    }
  };
  </script>
  